<template>
  <v-app>
    <router-view />
    <s-version-snackbar />
  </v-app>
</template>

<script>
import SVersionSnackbar from '@/versioning/components/SVersionSnackbar';

export default {
  name: 'App',
  components: {SVersionSnackbar},
  data() {
    return {
      quoteElapsed: false,
      unauthenticated: false,
      currentUserPromise: null,
    };
  },
};
</script>

<style lang="scss">
@import '~katex/dist/katex.min.css';

.text-bold {
  font-weight: bold;
}

.s-badge {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  border-radius: 9999px;
  font-weight: 500;
  letter-spacing: 0.025em;
  width: fit-content;
  border-width: 1.5px;
  border-style: solid;
  box-shadow:
    inset 0.5px 2px 6px 0px rgba(44, 32, 80, 0.04),
    inset 0px 1px 2px 0px rgba(46, 36, 81, 0.03);
  line-height: 1;
}

.s-badge.sm {
  padding: 0.25rem 0.5rem !important;
  font-size: 0.75rem !important;
}

.s-badge.md {
  padding: 0.375rem 0.75rem !important;
  font-size: 0.875rem !important;
}

.s-badge.lg {
  padding: 0.5rem 1rem !important;
  font-size: 1rem !important;
}

.s-badge.white {
  background-color: #fff !important;
  border-color: #e5e7eb !important;
  color: #4a5568 !important;
}

.s-badge.gray {
  background-color: #f7fafc !important;
  border-color: #edf2f7 !important;
  color: #4a5568 !important;
}

.s-badge.blue {
  background-color: #d5edf8 !important;
  border-color: #abdaf1 !important;
  color: #2c7cbe !important;
}

.s-badge.green {
  background: #e5f9e6 !important;
  border-color: #bff0c1 !important;
  color: #449c47 !important;
}

.s-badge.yellow {
  background-color: #ffffcc !important;
  border-color: #ff9700 !important;
  color: #ff3301 !important;
}

.s-badge.red {
  background-color: #ffcc33 !important;
  border-color: #ff3301 !important;
  color: #ff3301 !important;
}
</style>
